import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { coverageOptionsBySchedule, quotesWithOffered, type ConsumerQuote } from '@shared/consumerPlan';
import { consumerApi, consumerQuoteKeys } from '../api/consumer-api';

export function useConsumerQuotes(clientId: string) {
  const query = useQuery({
    queryKey: consumerQuoteKeys.detail(clientId),
    queryFn: () => consumerApi.getQuotes(clientId),
    enabled: !!clientId,
    staleTime: 5 * 60 * 1000,
  });

  // `quotes` holds every quote a saved key can point at, including the re-priced options.
  const { quotes, coverageOptions } = useMemo(() => {
    const stored = (query.data?.quotes ?? []) as ConsumerQuote[];
    const options = query.data?.coverageOptions ?? coverageOptionsBySchedule(stored);
    return { quotes: quotesWithOffered(stored, options, query.data?.chosenQuote), coverageOptions: options };
  }, [query.data]);

  return {
    quotes,
    coverageOptions,
    carrierCount: query.data?.carrierCount ?? 0,
    usaState: query.data?.usaState ?? null,
    noQuotesReason: query.data?.noQuotesReason,
    isLoading: query.isLoading,
    isError: query.isError,
    refetch: query.refetch,
  };
}
